import script from "./PatientInfoTool.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientInfoTool.vue?vue&type=script&setup=true&lang=js"

import "./PatientInfoTool.vue?vue&type=style&index=0&id=affd8aa4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-affd8aa4"]])

export default __exports__